<template>
  <!-- Device groups -->
  <TriggerComponentDeviceGroups class="pa-0" :deviceGroupsChosen="deviceGroupsChosen"/>
  <!-- Source type -->
  <v-row class="my-0 pt-4 pb-0">
    <v-col cols="3" class="py-1 pr-0">{{ $t("source") }}: </v-col>
    <v-col cols="9" class="py-1 pr-0">
      <div class="radio-container mx-4" @click="togglePolicySource(TriggerPolicyConnectionSourceEnum.VPN)">
        <v-icon 
          :color="policy.source == TriggerPolicyConnectionSourceEnum.VPN ? 'var(--color-highlight)' : 'var(--color-g4)'"
          class="ecc" 
          style="font-size:22px">{{policy.source == TriggerPolicyConnectionSourceEnum.VPN  ? 'ecc:ecc-E-RadioON' : 'ecc:ecc-E-RadioOFF'}}</v-icon>
        <div class="radio-text">{{ $t('VPN') }}</div>
      </div>
      <div class="radio-container" @click="togglePolicySource(TriggerPolicyConnectionSourceEnum.IOT)">
        <v-icon 
          :color="policy.source == TriggerPolicyConnectionSourceEnum.IOT ? 'var(--color-highlight)' : 'var(--color-g4)'"
          class="ecc" 
          style="font-size:22px">{{policy.source == TriggerPolicyConnectionSourceEnum.IOT ? 'ecc:ecc-E-RadioON' : 'ecc:ecc-E-RadioOFF'}}</v-icon>
        <div class="radio-text">{{ $t('IOT') }}</div>
      </div>
    </v-col>
  </v-row>
  <!-- Status -->
   <v-row class="my-0 pt-4 pb-0">
    <v-col cols="3" class="py-1 pr-0">{{ $t("status") }}: </v-col>
    <v-col cols="9" class="py-1 pr-0">
      <div class="radio-container mx-4" @click="togglePolicyStatus(TriggerPolicyConnectionStatusEnum.ON)">
        <v-icon 
          :color="policy.status == TriggerPolicyConnectionStatusEnum.ON ? 'var(--color-highlight)' : 'var(--color-g4)'"
          class="ecc" 
          style="font-size:22px">{{policy.status == TriggerPolicyConnectionStatusEnum.ON  ? 'ecc:ecc-E-RadioON' : 'ecc:ecc-E-RadioOFF'}}</v-icon>
        <div class="radio-text">{{ $t('ON') }}</div>
      </div>
      <div class="radio-container" @click="togglePolicyStatus(TriggerPolicyConnectionStatusEnum.OFF)">
        <v-icon 
          :color="policy.status == TriggerPolicyConnectionStatusEnum.OFF ? 'var(--color-highlight)' : 'var(--color-g4)'"
          class="ecc" 
          style="font-size:22px">{{policy.status == TriggerPolicyConnectionStatusEnum.OFF ? 'ecc:ecc-E-RadioON' : 'ecc:ecc-E-RadioOFF'}}</v-icon>
        <div class="radio-text">{{ $t('OFF') }}</div>
      </div>
    </v-col>
  </v-row>
  <!-- time -->
  <v-row class="my-1">
    <v-col class="py-0">
      <v-text-field
        v-model="policy.time"
        type="number"
        :min="0"
        :step="0"
        :label="$t('time')"
        data-qa="prop-control-grid-time"
        hide-details>
      </v-text-field>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import TriggerComponentDeviceGroups from "./TriggerComponentDeviceGroups.vue";
import {
  TriggerPolicyConnection,
  TriggerPolicyConnectionSourceEnum,
  TriggerPolicyConnectionStatusEnum,
  TriggerPolicySourceEnum,
  TriggerPolicyTypeEnum,
} from "./type.util";

export default defineComponent({
  name: "TriggerPolicyAnalogBandComponent",
  components: {
    TriggerComponentDeviceGroups,
  },
  data() {
    return {
      TriggerPolicyTypeEnum: TriggerPolicyTypeEnum,
      TriggerPolicyConnectionSourceEnum: TriggerPolicyConnectionSourceEnum,
      TriggerPolicySourceEnum: TriggerPolicySourceEnum,
      TriggerPolicyConnectionStatusEnum: TriggerPolicyConnectionStatusEnum,
    };
  },
  props: {
    policy: {
      type: Object as () => TriggerPolicyConnection,
      default: null,
    },
    deviceGroupsChosen: {
      type: Array,
      default: [],
    },
  },
  methods: {
    togglePolicySource(source: TriggerPolicyConnectionSourceEnum) {
      this.policy.source = source;
    },
    togglePolicyStatus(status: TriggerPolicyConnectionStatusEnum) {
      this.policy.status = status;
    },
  },
});
</script>

<style scoped>
.header {
  font-weight: bold;
}
.radio-container {
  display: inline-flex;
  cursor: pointer;
}

.radio-text{
  margin: auto;
}
</style>
